// extracted by mini-css-extract-plugin
export default {"value":"NutritionValue_value__iBPzv"};